// src/services/roleService.ts
import { api } from './api';
import { Role } from '../services/authService';

interface RoleResponse {
  message: string;
  data: Role;
  error: boolean;
}


export interface RoleFormData {
  name: string;
  description: string;
  permissions: any[];
}

export const roleService = {
  async getAllRoles(): Promise<Role[]> {
    const response = await api.get('/role');
    return response.data.data.result;
  },
  
  async getRole(id: string): Promise<Role> {
    const response = await api.get<RoleResponse>(`/role/${id}`);
    return response.data.data;
  },
  
  async createRole(roleData: RoleFormData): Promise<Role> {
    const response = await api.post<RoleResponse>('/role', roleData);
    return response.data.data;
  },
  
  async updateRole(id: string, roleData: RoleFormData): Promise<Role> {
    const response = await api.put<RoleResponse>(`/role/${id}`, roleData);
    return response.data.data;
  },
  
  async deleteRole(id: string): Promise<void> {
    await api.delete(`/role/${id}`);
  }
};